type StorageKey = 'ember:activeActivityId' | 'ember:weekStart' | 'ember:reducedFx';

export const storage = {
  get<T>(key: StorageKey, fallback: T): T {
    try {
      const raw = window.localStorage.getItem(key);
      if (raw === null) return fallback;
      return JSON.parse(raw) as T;
    } catch {
      return fallback;
    }
  },
  set(key: StorageKey, value: unknown): void {
    try {
      window.localStorage.setItem(key, JSON.stringify(value));
    } catch {
      /* quota or disabled */
    }
  },
  remove(key: StorageKey): void {
    try {
      window.localStorage.removeItem(key);
    } catch {
      /* noop */
    }
  },
};
